import { render, staticRenderFns } from "./to-do-app.vue?vue&type=template&id=4ff35cd1&scoped=true"
import script from "./to-do-app.vue?vue&type=script&lang=js"
export * from "./to-do-app.vue?vue&type=script&lang=js"
import style0 from "./to-do-app.vue?vue&type=style&index=0&id=4ff35cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff35cd1",
  null
  
)

export default component.exports